import gql from 'graphql-tag'

// POST /api/inbound-issue/list
const inboundIssuesGetQuery = gql`
  query inboundIssuesGet($offset: Int, $limit: Int, $criteria: Object, $sorting: Object, $nested: Boolean) {
    inboundIssuesGet(input: { limit: $limit, offset: $offset, criteria: $criteria, sort: $sorting, nested: $nested })
      @rest(type: "InboundIssuesListResult", method: "POST", path: "inbound-issue/list") {
      results
      paging
    }
  }
`

export default inboundIssuesGetQuery
